/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_UpdatingInputs */

const en_samples_updating = /** @type {(inputs: Samples_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating...`)
};

const es_samples_updating = /** @type {(inputs: Samples_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizando...`)
};

/**
* | output |
* | --- |
* | "Updating..." |
*
* @param {Samples_UpdatingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_updating = /** @type {((inputs?: Samples_UpdatingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_UpdatingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_updating(inputs)
	return es_samples_updating(inputs)
});